module.exports = __webpack_public_path__ + "img/20210730_121315.ab6ca9e3.jpg";